import type { Store } from '@reduxjs/toolkit';
import type RootState from 'app-components/utils/redux-store/rootState';
import asyncDispatchMiddleware from './asyncDispatchMiddleware';
import * as immutableSerialize from './immutableSerialize';
export * from './sagaMiddleware';
export * from './crashReporterMiddleware';

let gStore: Store<RootState> | null = null;

export const inject = (newStore: Store<RootState>) => {
  gStore = newStore;
};

export { gStore as default };
export { immutableSerialize, asyncDispatchMiddleware };
